import { render } from "./GymTabs.vue?vue&type=template&id=3fff8c46&scoped=true"
import script from "./GymTabs.vue?vue&type=script&lang=js"
export * from "./GymTabs.vue?vue&type=script&lang=js"

import "./GymTabs.vue?vue&type=style&index=0&id=3fff8c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fff8c46"]])

export default __exports__